module.exports = __webpack_public_path__ + "static/media/pic7.fe663f10.jpg";